/**
 * In-Context Booking Status enum values for the `inContextBookingStatus` configuration field.
 *
 * - Inactive: Web components are fully suppressed for all users.
 * - Staged:   Components are published to the hotel site but hidden from guests; preview via bookmarklet only.
 * - Live:     Components are active and visible to all guests.
 */
export const IN_CONTEXT_BOOKING_STATUS = {
    INACTIVE: 'Inactive',
    STAGED: 'Staged',
    LIVE: 'Live'
};



// WEBPACK FOOTER //
// ./src/constants/InContextBookingStatus.js